import styled from "styled-components";

import { ToggleHeaderCell } from "./ToggleHeaderCell";

export const ToggleHeaderCellRightAlign = styled(ToggleHeaderCell)`
    text-align: right;
    width: 100%;
`;
